import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const UnderlineIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M5.32128 0.666626V7.93463C5.32128 9.92863 6.05395 10.9606 8.00395 10.9606C9.95395 10.9606 10.6853 9.92863 10.6853 7.93463V0.666626H12.6706V7.63063C12.6706 11.0786 11.4193 12.6666 8.00395 12.6666C4.58861 12.6666 3.33728 11.078 3.33728 7.63063V0.666626H5.32128Z"
        fill={color}
      />
      <path d="M1.33337 15.3333V14H14.6667V15.3333H1.33337Z" fill={color} />
    </BaseIcon>
  ),
);

UnderlineIcon.displayName = 'UnderlineIcon';
